export default __webpack_public_path__ + "static/media/justificacao-faltas.2fc6afea.svg";